// Force les liens des menus déroulants à être cliquables
document.addEventListener('DOMContentLoaded', function() {
  // Sélectionner tous les liens dans le menu de navigation
  const menuLinks = document.querySelectorAll('header nav a, header nav button');
  
  menuLinks.forEach(function(link) {
    // Si c'est un bouton avec un attribut href ou data-href, le rendre cliquable
    if (link.tagName === 'BUTTON') {
      const href = link.getAttribute('data-href') || link.getAttribute('href');
      if (href) {
        link.style.cursor = 'pointer';
        link.addEventListener('click', function(e) {
          e.stopPropagation();
          window.location.href = href;
        });
      }
    }
    
    // Forcer tous les liens <a> à être cliquables
    if (link.tagName === 'A') {
      link.style.pointerEvents = 'auto';
      link.style.cursor = 'pointer';
    }
  });
  
  // Forcer les sous-menus à être cliquables
  const dropdownLinks = document.querySelectorAll('.menu__item--dropdown a, [data-menu-item] a');
  dropdownLinks.forEach(function(link) {
    link.style.pointerEvents = 'auto';
    link.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
});
